import gql from 'graphql-tag';
import { importFragment } from '@/graphql-fragments';

export const GET_IMPORTS = gql`
  query getImports(
    $type: String!
    $pagination: PaginationAttributes
    $date: ISO8601Date
  ) {
    items:imports(type: $type, pagination: $pagination, date: $date) {
      ...import
    }
  }
  ${importFragment}
`;

export const RESTORE_PRODUCTS = gql`
  mutation restoreImportedProducts(
    $input: RestoreImportedProductsInput!
  ) {
    restoreImportedProducts(input: $input) {
      import {
        id
        productsCount
        createdAt
        state
      }
    }
  }
`;

export const DELETE_PRODUCTS = gql`
  mutation deleteImportedProducts(
    $input: DeleteImportedProductsInput!
  ) {
    deleteImportedProducts(input: $input) {
      import {
        ...import
      }
    }
  }
  ${importFragment}
`;

export const GET_PRODUCTS = gql`
  query getProducts(
    $importId: Int!
    $pagination: PaginationAttributes
    $search: String
  ) {
    products(importId: $importId, search: $search, pagination: $pagination) {
      id
      name
      price
    }
  }
`;
